<template>
  <TabPanel class="tw-w-full">
    <Box rounded="xlarge" class="tw-col-span-full md:tw-col-span-8">
      <iframe
        v-if="grafanaUrl"
        :src="grafanaUrl"
        class="tw-h-[820px] tw-w-full tw-rounded-[12px]"
        title="Grafana monitoring"
      />

      <Text v-else size="large" class="tw-text-center tw-text-white/68">{{ t('monitoring.grafana_unavailable') }}</Text>
    </Box>
  </TabPanel>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { Box, TabPanel, Text } from '@slideslive/fuse-kit/vue';

import useStateStore from '@/stores/state';
import toBrowserHost from '@/utils/station_url';

const { t } = useI18n();

const stateStore = useStateStore();
const { state } = storeToRefs(stateStore);

const grafanaUrl = computed(() => {
  const app = state.value?.data?.app;
  return toBrowserHost(app?.dashboard_nate_monitoring_url?.trim(), app?.host_url);
});
</script>
